<template>
	<div class="sidebar-site-editor">
		<div class="row">
			<div class="col-6">
				<erco-options-group label="Sprache"
				                    size="sm"
				                    :options="langs"
				                    @click="handleLangClick">
				</erco-options-group>
			</div>
			<div class="col-6">
				<erco-dropdown class="mr-3"
				               label="Paginierung"
				               size="sm"
				               :items="pagination.items"
				               :currentItemIndex="pagination.selectedIndex"
				               @change="handlePaginationChange">
				</erco-dropdown>
				<erco-dropdown class="mr-3"
				               label="Abstand unten"
				               size="sm"
				               :items="distanceBelow.items"
				               :currentItemIndex="distanceBelow.selectedIndex"
				               @change="handleDistanceBelowChange">
				</erco-dropdown>
				<erco-dropdown class="mr-3"
				               label="Hintergrund"
				               size="sm"
				               :items="backgroundType.items"
				               :currentItemIndex="backgroundType.selectedIndex"
				               @change="handleBackgroundTypeChange">
				</erco-dropdown>
			</div>
		</div>
		<div class="row row-distance-above">
			<div class="col-12">
				<erco-text-input label="Überschrift"
				                 :text="title"
				                 @change="handleTitleChange">
				</erco-text-input>
			</div>
		</div>
		<div class="row">
			<div class="col-6">
				<div class="row">
					<div class="col-12 img-editor">
						<!-- BEGIN: TODO: Ersetzung durch Bildeditor-Komponente -->
						<label>
							<span class="label text-muted" style="margin: 0;">Bild</span>
							<img src="http://placehold.it/600x600" style="width: 100%; margin-top: 0.4rem;"></img>
						</label>
						<!-- END: TODO -->
					</div>
				</div>
				<div class="row">
					<div class="col-12">
						<erco-text-area class="image-subtitle"
						                 label="Bildunterschrift"
						                 :text="imageSubtitle"
						                 @change="handleImageSubtitleChange">
						</erco-text-area>
					</div>
				</div>
			</div>
			<div class="col-6">
				<div class="row subtitle-row">
					<div class="col-12">
						<erco-text-input label="Überschrift"
						                 :text="subtitle"
						                 @change="handleSubtitleChange">
						</erco-text-input>
					</div>
				</div>
				<div class="row text-row">
					<div class="col-12">
						<erco-text-area class="text-textarea"
						                label="Text"
						                :text="text"
						                @change="handleTextChange">
						</erco-text-area>
					</div>
				</div>
			</div>
		</div>

		<div class="multiform-items">
			<span class="title">Multiform</span>
			<div :class="['multiform-item', multiformItem.type]" v-for="multiformItem in multiformItems"
			                  :key="multiformItem.id">
			    <erco-text-input v-if="multiformItem.type === 'text'"
			                     :label="multiformItem.label"
			                     :text="multiformItem.values.value"
			                     @change="handleMultiformInputChange(index, $event)">
			    </erco-text-input>

			    <!-- TODO: Richtige Komponente wählen -->
			    <erco-text-input v-else-if="multiformItem.type === 'image'"
			                     :label="multiformItem.label"
			                     :text="multiformItem.values.value"
			                     @change="handleMultiformInputChange(multiformItem, $event)">
			    </erco-text-input>

			    <div v-else>
			    	Unbekannter Item-Typ: {{ multiformItem.type }}
			    </div>
			</div>
		</div>
	</div>
</template>

<script>
	import Const from '@/constants';

	import ErcoOptionsGroup from '@/components/molecules/ErcoOptionsGroup';
	import ErcoDropdown from '@/components/molecules/ErcoDropdown';
	import ErcoTextInput from '@/components/molecules/ErcoTextInput';
	import ErcoTextArea from '@/components/atoms/ErcoTextArea';

	export default {
		name: 'ErcoSidebarSideEditorMolecule',

		props: {
			data: {
				type: Object,
				default: () => {},
			},
		},

		data() {
			return {
				langs: Const.langs.map((lang, index) => {
					lang.active = (index === 0);
					return lang;
				}),
			};
		},

		computed: {
			pagination() {
				return {
					items: [
						{ text: 'ja', value: true },
						{ text: 'nein', value: false },
					],
					selectedIndex: 1,
				};
			},

			distanceBelow() {
				return {
					items: [
						{ text: 'mittel', value: 'middle' },
					],
					selectedIndex: 0,
				};
			},

			backgroundType() {
				return {
					items: [
						{ text: 'Story', value: 'story' },
					],
					selectedIndex: 0,
				};
			},

			title() {
				return '';
			},

			imageSubtitle() {
				return '';
			},

			subtitle() {
				return '';
			},

			text() {
				return '';
			},

			multiformItems() {
				const Types = {
					text: 'text',
					bild: 'image',
				};

				return Object.keys(this.data.items).map((itemKey) => {
					const item = this.data.items[itemKey];
					const type = Types[item.typ] || item.typ;

					const restrictions = {};

					const values = {
						value: item.value && item.value.trim(),
						height: item.height && parseInt(item.height, 10),
						width: item.width && parseInt(item.width, 10),
					};

					switch (type) {
						case 'text':
							/* Restriktionen */
							restrictions.charlength = item.charlength ? parseInt(item.charlength, 10) : null;

							/* Andere */
							values.tag = item.tag || null;
							break;

						case 'image':
							/* Seitenverhältnisse */
							values.ratios = item.ratios;

							if (typeof (values.ratios) === 'string') {
								const matches = values.ratios.match(/\[(.*)\]/);
								if (matches) {
									values.ratios = matches[1].split(',').map(ratio => parseInt(ratio, 10));
								}
							} else {
								values.ratios = null;
							}

							/* Andere */
							values.dimension = item.dimension || null;
							break;

						default:
					}

					return {
						id: itemKey,
						number: item.nummer,
						type: Types[item.typ] || item.typ,
						label: `Position ${item.U_Position}`,
						restrictions,
						values,
					};
				});
			},
		},

		methods: {
			handleLangClick(option) {
				throw new Error(`SiteEditor > Lang ${option}`);
			},

			handlePaginationChange(item) {
				throw new Error(`SiteEditor > Pagination ${item}`);
			},

			handleDistanceBelowChange(item) {
				throw new Error(`SiteEditor > DistanceBelow ${item}`);
			},

			handleBackgroundTypeChange(item) {
				throw new Error(`SiteEditor > BackgroundType ${item}`);
			},

			handleTitleChange(value) {
				throw new Error(`SiteEditor > Title ${value}`);
			},

			handleImageSubtitleChange(value) {
				throw new Error(`SiteEditor > ImageSubtitle ${value}`);
			},

			handleSubtitleChange(value) {
				throw new Error(`SiteEditor > Subtitle ${value}`);
			},

			handleTextChange(value) {
				throw new Error(`SiteEditor > Text ${value}`);
			},

			handleMultiformInputChange(item, value) {
				throw new Error(`SiteEditor > MultiformItem ${item.id} ${value}`);
			},
		},

		components: {
			ErcoOptionsGroup,
			ErcoDropdown,
			ErcoTextInput,
			ErcoTextArea,
		},
	};
</script>

<style lang="scss">

	.sidebar-site-editor {
		padding: 0.5rem;
		padding-top: 1.5rem;

		& > .multiform-items {
			margin-top: 2rem;

			& > .title {
				display: inline-block;
				font-weight: bold;
				margin-bottom: 1.5rem;
			}
		}

		.row-distance-above {
			margin-top: 2.5rem;
		}

		.image-subtitle {
			margin-top: 1rem;
		}

		.subtitle-row {
			height: 5.5rem;
		}

		.text-row {
			height: calc(100% - 7.85rem);

			.text-textarea {
				height: 100%;
			}
		}
	}

</style>



// WEBPACK FOOTER //
// SiteEditor.vue?bc491b02